import { IMenuItem } from 'types/menu';

export enum IFavoritesActionTypes {
  ADD_FAVORITE = 'FAVORITES/ADD_FAVORITE',
  REMOVE_FAVORITE = 'FAVORITES/REMOVE_FAVORITE',
  CLEAR_FAVORITES = 'FAVORITES/CLEAR_FAVORITES',
  CLEANUP_FAVORITES = 'FAVORITES/CLEANUP_FAVORITES',
}

export interface IFavoriteItem {
  moduleId: string; // Unique identifier for the module
  module: IMenuItem;
  language: string;
  courseName: string;
  addedAt: number; // Timestamp
}

interface IAddFavoriteAction {
  type: IFavoritesActionTypes.ADD_FAVORITE;
  payload: IFavoriteItem;
}

interface IRemoveFavoriteAction {
  type: IFavoritesActionTypes.REMOVE_FAVORITE;
  payload: string; // moduleId
}

interface IClearFavoritesAction {
  type: IFavoritesActionTypes.CLEAR_FAVORITES;
}

interface ICleanupFavoritesAction {
  type: IFavoritesActionTypes.CLEANUP_FAVORITES;
  payload: string[]; // Array of valid module IDs
}

export type IFavoritesActions = IAddFavoriteAction | IRemoveFavoriteAction | IClearFavoritesAction | ICleanupFavoritesAction;

export const addFavorite = (favorite: IFavoriteItem): IAddFavoriteAction => ({
  type: IFavoritesActionTypes.ADD_FAVORITE,
  payload: favorite,
});

export const removeFavorite = (moduleId: string): IRemoveFavoriteAction => ({
  type: IFavoritesActionTypes.REMOVE_FAVORITE,
  payload: moduleId,
});

export const clearFavorites = (): IClearFavoritesAction => ({
  type: IFavoritesActionTypes.CLEAR_FAVORITES,
});

export const cleanupFavorites = (validModuleIds: string[]): ICleanupFavoritesAction => ({
  type: IFavoritesActionTypes.CLEANUP_FAVORITES,
  payload: validModuleIds,
});